import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "actions" }

import { computed, ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { sendQuotation } from "@/shared/services/quotations.api";
import { useSnackbarStore } from "@/shared/stores/snackbar";


export default /*@__PURE__*/_defineComponent({
  __name: 'UseQuotationTemplateModal',
  props: {
    inquiryId: {},
    quotationTemplateId: {},
    summary: {},
    onSuccess: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const snackbar = useSnackbarStore();
const isSubmitting = ref(false);

const inquiryIdValue = computed(() => props.inquiryId);
const quotationTemplateIdValue = computed(() => props.quotationTemplateId);

async function handleConfirm() {
  if (isSubmitting.value) return;

  isSubmitting.value = true;
  try {
    if (inquiryIdValue.value == null || String(inquiryIdValue.value).trim() === "") {
      snackbar.error("Inquiry ID missing.");
      return;
    }
    if (
      quotationTemplateIdValue.value == null ||
      String(quotationTemplateIdValue.value).trim() === ""
    ) {
      snackbar.error("Template ID missing.");
      return;
    }

    await sendQuotation(inquiryIdValue.value, {
      quotation_template_id: quotationTemplateIdValue.value,
      summary: props.summary ?? undefined,
    });
    snackbar.success("Quotation sent.");
    await props.onSuccess?.();
    modal.close();
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to send quotation.";
    snackbar.error(message);
  } finally {
    isSubmitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, { class: "" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "Send quotation", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "subtitle" }, " Send quotation using this template? ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AppButtonFlat, {
          block: "",
          type: "button",
          "prepend-icon": isSubmitting.value ? undefined : 'mdi-check-circle-outline',
          loading: isSubmitting.value,
          disabled: 
          isSubmitting.value ||
          inquiryIdValue.value == null ||
          String(inquiryIdValue.value).trim() === '' ||
          quotationTemplateIdValue.value == null ||
          String(quotationTemplateIdValue.value).trim() === ''
        ,
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Confirm ", -1)
          ]))]),
          _: 1
        }, 8, ["prepend-icon", "loading", "disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})